















import DataString from './DataString.vue';


export default DataString.extend({
  props: {
    maxHeight: {
      type: String,
    },
  },
  computed: {
    containerStyle() {
      return { 
        maxHeight: this.maxHeight,
        height: 'auto',
      };
    },
  },
});
